export const AJUDA =
  'As fotos são as imagens dentro desta página, na ordem da tela Conteúdo.';

const GaleriaSchema = () => ({
  title: 'Galeria de fotos',
  fieldsets: [{ id: 'default', title: 'Padrão', fields: ['title'] }],
  properties: {
    title: {
      title: 'Título da galeria',
      description:
        'Opcional. Aparece acima das fotos, como subtítulo da página.',
    },
  },
  required: [],
});

export default GaleriaSchema;
